<div class="pricelist-container">
    <div class="speciality-pricelist-container">
        <div class="title-container-pricelist" [ngStyle]="{ width: '100%', 'align-items': 'center' }">
            <div class="title">
                <div class="choose-container">
                    <div class="choose-map">
                        <div class="choose">
                            <h1>Árlista</h1>
                        </div>
                        <div class="choose">
                            <h3>Átlátható, korrekt díjszabás</h3>
                        </div>
                        <div class="choose">
                            <p>
                                Minden kezelésünk aktuális költségét megtalálja az alábbi listában! Rendelőnkben van lehetősége
                                bankkártyával vagy egészségkártyával is fizetni!
                            </p>
                        </div>
                        <div class="choose">
                            <button routerLink="/healthfund" target="_blank">EGÉSZSÉGPÉNZTÁRI PARTNEREINK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="speciality">
            <div class="icons">
                <div class="icon">
                    @if (!showExamination) {
                        <mat-icon (click)="showExaminationElement()">add_circle</mat-icon>
                    }
                    @if (showExamination) {
                        <mat-icon (click)="showExaminationElement()">remove_circle_outline</mat-icon>
                    }
                </div>
            </div>
            <div class="spec">
                @for (speciality of specialities; track speciality; let i = $index) {
                    <div class="speciality-element">
                        <div class="name-container">
                            <div class="name" (click)="chooseOneSpeciality(speciality)">
                                <p>
                                    <b [ngStyle]="{ 'font-size': '18px' }">{{ speciality.name! | uppercase }}</b>
                                </p>
                            </div>
                            @if (speciality.hasSpecialityChosen && speciality.isVisible) {
                                <div class="exam">
                                    @for (examination of speciality.examinationList; track examination; let i = $index) {
                                        <div
                                            class="examination-container"
                                            [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#f2f2f2' }"
                                        >
                                            <div class="examination">
                                                <div class="examination-name">
                                                    <span>{{ examination.name }}</span>
                                                </div>
                                                @if (examination.price) {
                                                    <div class="examination-price">
                                                        <span>{{ examination.price | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
                                                    </div>
                                                }
                                                @if (!examination.price) {
                                                    <div class="examination-price">
                                                        <span
                                                            >{{ examination.minPrice | currency: 'Ft' : 'symbol' : '1.0-0' }} -
                                                            {{ examination.maxPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</span
                                                        >
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            @if (showExamination) {
                                <div class="exam">
                                    @for (examination of speciality.examinationList; track examination; let i = $index) {
                                        <div
                                            class="examination-container"
                                            [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#f2f2f2' }"
                                        >
                                            <div class="examination">
                                                <div class="examination-name">
                                                    <span>{{ examination.name }}</span>
                                                </div>
                                                <div class="examination-price">
                                                    <span>{{ examination.price | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
